import { defineModule } from '@core/index';
import ILSValidate from './containers';

export default defineModule({
  title: 'Валидация',
  component: ILSValidate,
  api: { Component: ILSValidate } as any
});
